<script setup lang="ts">

import { useGameStore } from "@/stores/gameStore.ts";
import { useShipStore } from '@/stores/shipStore.ts';
import { computed, ref, watch } from 'vue';
import MapSelectPlayerShips from '@/components/Interface/Modal/Modals/ModalMapSelectPlayerShips/MapSelectPlayerShips.vue'
import MapSelectPlayerFleets from '@/components/Interface/Modal/Modals/ModalMapSelectPlayerShips/MapSelectPlayerFleets.vue'
import LargeWideModel from '@/components/Interface/Modal/ModelSizes/LargeWideModel.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// Get the planet data
const gameStore = useGameStore();
const shipStore = useShipStore();

const currentTab = ref('ships');

const tabStats = computed(() => {
  let stats = { fleets: 0, ships: 0 };
  let fleets: Record<number, boolean> = {}

  for (let ship of shipStore.ships.values()) {
    if(ship.xPos !== gameStore.modalData.xPos || ship.yPos !== gameStore.modalData.yPos) {
      continue;
    }
    if(ship.fleetId == 0) {
      stats.ships++
    } else {
      fleets[ship.fleetId] = true;
    }
  }

  stats.fleets = Object.keys(fleets).length;

  return stats;
});

// Watch for fleet count changes and set default tab
watch(() => tabStats.value.fleets, (fleetCount) => {
  if (fleetCount > 0 && currentTab.value === 'ships') {
    currentTab.value = 'fleets';
  }
}, { immediate: true });


</script>

<template>
  <LargeWideModel :title="t('modals.mapSelect.title', { x: gameStore.modalData.xPos, y: gameStore.modalData.yPos })">
    <div class="text-sm font-medium text-center border-b text-gray-400 border-gray-700">
      <ul class="flex flex-wrap">
        <li class="me-2">
          <a href="#"
             :class="{
               'active-blue': currentTab === 'ships',
               'text-blue-500 border-blue-500': currentTab === 'ships',
               'text-gray-500 border-transparent': currentTab !== 'ships',
               'inline-block p-4 border-b-2 rounded-t-lg hover:border-gray-300 hover:text-gray-300': true
           }"
             @click="currentTab = 'ships'">
            {{ t('modals.mapSelect.tabs.ships') }} <span v-if="tabStats.ships>0" class="text-white">({{ tabStats.ships }})</span>
          </a>
        </li>
        <li class="me-2">
          <a href="#"
             :class="{
               'active-blue': currentTab === 'fleets',
               'text-blue-500 border-blue-500': currentTab === 'fleets',
               'text-gray-500 border-transparent': currentTab !== 'fleets',
               'inline-block p-4 border-b-2 rounded-t-lg  hover:border-gray-300 hover:text-gray-300': true
           }"
             @click="currentTab = 'fleets'">
            {{ t('modals.mapSelect.tabs.fleets') }} <span v-if="tabStats.fleets>0" class="text-white">({{ tabStats.fleets }})</span>
          </a>
        </li>
      </ul>
    </div>
    <div v-if="currentTab === 'ships'" class="p-1">
      <MapSelectPlayerShips />
    </div>
    <div v-else-if="currentTab === 'fleets'" class="p-1">
      <MapSelectPlayerFleets />
    </div>
  </LargeWideModel>
</template>

<style scoped lang="scss">
.active-blue {
  background: linear-gradient(
    to top,
    rgba(59, 130, 246, 0.3) 0%,
    rgba(59, 130, 246, 0) 70%
  );
}
</style>
